import { Language } from '@shared/openapi/jaaluu-api';
import { ref } from 'vue';
const MAX_WORDS_BLOCK = 15;
export default () => {
  const activeText = ref('');

const getMaxText = (text: string, maxWords = 30, lang?: Language) => {
  if (lang == Language.ZH) {
    const words = text.split('');
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join('') + '...';
  }
  const words = text.split(' ');
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(' ') + '...';
};

  return { state: { activeText }, funcs: { getMaxText }, consts: { MAX_WORDS_BLOCK } };
};
